import {useAuth} from "../../providers/authprovider";
import React, {useEffect, useState} from "react";
import {Button, Form} from "react-bootstrap";
import {v4 as uuidv4} from "uuid";
import {useNavigate, useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faEye, faSave, faSpinner} from "@fortawesome/free-solid-svg-icons";
import useAlert from "../../components/CustomAlert";
import ProvideFormContext, {BuildHtmlElement} from "../../components/forms/formElements"
import OfferMigrationDialog from "./OfferMigrationDialog";


function replaceInTree(elements, element){

    function updateValue(nodes, element){
        for(let i in nodes){
            const node = nodes[i];

            if(node.name === element.name){
                nodes[i].value = element.value
                return;
            }

            if(node.children && Array.isArray(node.children)){
                updateValue(node.children, element)
            }
        }
    }

    updateValue(elements, element);


    return [...elements]
}

function hasMigratableOfferTable(elements){
    for(let element of elements){
        if(element.type === "table_offer")
            return true;

        if(element.name === "table_assortments")
            return true;

        if(element.children && Array.isArray(element.children)){
            if(hasMigratableOfferTable(element.children))
                return true;
        }
    }

    return false;
}

export default function CreateTemplateForm(props) {

    const {templateId, offerType} = useParams();
    const navigate = useNavigate();
    const {alert, hideAlert, showAlert} = useAlert();
    const [assortments, setAssortments] = useState();
    const [workers, setWorkers] = useState();
    const [dirtyState, setDirty] = useState(false);
    const [downloading, setDownloading] = useState(false)
    const [showMigrationDialog, setShowMigrationDialog] = useState(false);
    const {assortments:{get: getAssortments},users, offers, viewPdf} = useAuth();
    const [formData, setFormData] = useState()


    useEffect(()=>{

        getAssortments(({success, error, content})=>{
            if(!success)
                return showAlert(error);
            setAssortments(content);
        })

        users.get(({success, error, content})=>{

            if(success === true) {
                setWorkers(content)
                return;
            }

            showAlert(error);
        }, 'offers');

    }, [])

    useEffect(()=>{

        if(templateId) {
            offers.templates.getById(templateId, ({success, error, content})=>{
                if(!success)
                    return showAlert(error);

                setFormData(content);
            })
            return
        }

        offers.getTemplate(offerType, ({success, error, content})=>{
            if(success)
                return setFormData({
                    id: uuidv4(),
                    client: undefined,
                    date: new Date().toJSON().substring(0,10),
                    name:'',
                    toWhom: '',
                    type: offerType,
                    building:{},
                    elements: content.elements
                })

            if(error)
                return showAlert(error)

            return showAlert("Wystapił nieznany błąd.")
        })

    }, [templateId])

    const data = {
        workers: workers,
        assortments: assortments,
        filter: null,
        onChange : function(element){
            setFormData((form)=>{
                setDirty(true)
                form.elements = replaceInTree(form.elements, element)
                return {...form}
            })
        },
        onRemoveSection : function(element){
            window.alert("Ta funkcja jest wyłączona w szablonach.")
        },
        tableTextAsTextarea: true
    }

    const handleCloseEdition = ()=>{
        if(dirtyState === false)
            return navigate(-1);

        let close = window.confirm("Formularz nie został zapisany. Zamknięcie spowoduje utratę danych. Czy chcesz zamknąć ?");

        if(close === false)
            return;

        return navigate(-1);
    }

    const handleSaveTemplate = ()=>{
        // W szablonach nie wymagamy kontrahenta ani obiektu, ale tytuł jest obowiązkowy.
        if(!formData.name || formData.name.trim() === ''){
            return showAlert("Podaj tytuł szablonu.");
        }

        const done = ({success, error, content})=>{
            if(!success)
                return showAlert(error);

            setFormData(content);
            setDirty(false);

            if(props.handleSave)
                props.handleSave(content);
        };

        if(templateId)
            offers.templates.update(templateId, formData, done);
        else
            offers.templates.create(formData, done);
    }

    const handleDisplayProtocol = ()=>{

        hideAlert()

        offers.displayOffer(formData, ({success, error, content})=>{
            if(success)
                return viewPdf(content)

            showAlert(error)
        })
    }

    const handleSetTemplateName = (event)=>{
        setDirty(true)
        setFormData({...formData, name:event.target.value})
    }

    const handleMigrateTemplate = (elements) => {
        setFormData({
            ...formData,
            elements: elements,
        });
        setDirty(true);
        setShowMigrationDialog(false);
    }

    const canMigrateTemplate = formData && hasMigratableOfferTable(formData.elements);

    return (
        <ProvideFormContext value={data} >
            <div className={"position-relative offer-form"}>
                <div className={"position-sticky bg-light"} style={{top:0, left:0, zIndex:99}}>
                    {alert()}
                    <div className={"d-flex justify-content-end"}>
                        <Button variant={"outline-secondary"} className={"m-2"} onClick={handleCloseEdition} ><FontAwesomeIcon icon={faArrowLeft} /> Powrót</Button>
                        {canMigrateTemplate ? (
                            <Button variant={"outline-primary"} className={"m-2"} onClick={() => setShowMigrationDialog(true)}>
                                Migracja oferty
                            </Button>
                        ) : null}
                        <Button variant={"success"} className={"m-2"} onClick={handleSaveTemplate} disabled={!dirtyState} ><FontAwesomeIcon icon={faSave}  /> Zapisz</Button>
                        <Button variant={"info"} className={"m-2"} onClick={handleDisplayProtocol} >
                            {
                                downloading ? <FontAwesomeIcon icon={faSpinner} spin={true} /> : <><FontAwesomeIcon icon={faEye} /> Podgląd</>
                            }
                        </Button>
                    </div>
                </div>
                <OfferMigrationDialog
                    show={showMigrationDialog}
                    onHide={() => setShowMigrationDialog(false)}
                    elements={formData?.elements}
                    onMigrate={handleMigrateTemplate}
                />
                {
                    formData &&
                    <>
                        <div className={'protocol_section'}>
                            <h4 className={"w-100 text-center"}>Podstawowe dane </h4>
                            <Form.Group className="m-2" controlId={"element.name"}>
                                <Form.Label>Tytuł szablonu</Form.Label>
                                <Form.Control   value={formData.name}  onChange={handleSetTemplateName} maxLength={20} placeholder={"wpisz krótko tytuł szablonu"} />
                                <Form.Text  muted>
                                    Pozostało { 20 - (formData.name?.length ?? 0)} znaków
                                </Form.Text>
                            </Form.Group>
                        </div>

                        {
                            formData.elements?.map((element, i)=>{
                                return <BuildHtmlElement key={i} element={element}  />
                            })
                        }
                    </>
                }
            </div>


        </ProvideFormContext>
    )

}
